import(/* webpackMode: "eager" */ "/vercel/path0/app/lessons/page.tsx");
